export const uiToken = {
  breakpoints: {
    desktop: '@media (min-width: 767px)',
  },

  color: {
    background: {
      main: '#000',
      secondary: '#191919',
      gray: '#BFC0E1',
      blue: '#6996FF40',
      transparent: '#FFFFFF1A',
      input: '#ffffff0d',
      glass: 'rgba(255 255 255 / 10%)',
      glassActive: 'rgba(105, 150, 255, 0.25)',
    },
    button: {
      default: '#326FFB',
      disabled: '#25252A',
      hover: '#1A419C',
      text: {
        disabled: '#48484a',
      },
      loading: '#4776E5',
    },
    lightButton: {
      default: '#BFC0E1',
      disabled: '#FFFFFF0D',
      hover: '#A9AAC7',
      text: {
        disabled: '#48484A',
      },
    },
    border: {
      active: '#2256CE',
      default: '#FFFFFF1A',
      disabled: '#FFFFFF1A',
      hover: '#2256CE',
      secondary: '#6996FFBF',
      glassActive: 'rgba(105, 150, 255, 0.75)',
    },
    link: {
      active: '#112c69',
      default: '#2256ce',
      hover: '#1a419c',
    },
    text: {
      disabled: '#333',
      primary: '#fff',
      secondary: '#808080',
      dark: '#190B3D',
      white75: '#ffffffbf',
    },
    shadow: {
      default: '#2256CE4D',
      error: '#FF456A4D',
    },
    system: {
      error: '#FF456A',
    },
    icon: {
      chevron: '#8C8C8C',
    },
    colors: {
      white: '#FFF',
    },
  },
  zIndex: {
    overlay: 1300,
    modal: 1400,
    notification: 1700,
  },
  animation: {
    durationFast: '0.2s',
  },
  mediaQuery: {
    forNoHover: '@media (hover: none)',
  },
} as const;
